import { render, staticRenderFns } from "./UATTab.vue?vue&type=template&id=66b46b98&scoped=true&"
import script from "./UATTab.vue?vue&type=script&lang=js&"
export * from "./UATTab.vue?vue&type=script&lang=js&"
import style0 from "./UATTab.vue?vue&type=style&index=0&id=66b46b98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b46b98",
  null
  
)

export default component.exports